import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import RankingCompareModal from '../../components/ranking/RankingCompareModalV2';

function RankingComparePopupPage() {
  const location = useLocation();

  const targets = useMemo(() => {
    const query = new URLSearchParams(location.search);
    const key = query.get('key');
    if (!key) return [];

    try {
      const raw = sessionStorage.getItem(key);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed?.targets) ? parsed.targets : [];
    } catch (error) {
      console.error('비교 팝업 데이터 파싱 실패:', error);
      return [];
    }
  }, [location.search]);

  const handleClose = () => {
    window.close();
    if (!window.closed) {
      window.location.href = '/ranking';
    }
  };

  if (targets.length < 2) {
    return (
      <div style={{ padding: 24, color: '#475569', fontWeight: 600 }}>
        표시할 비교 데이터가 없습니다.
      </div>
    );
  }

  return <RankingCompareModal targets={targets} onClose={handleClose} />;
}

export default RankingComparePopupPage;

